import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NavService } from '@app/services/nav.service';
import { AccountDownloadsPage } from '../account-downloads/account-downloads.page';
import { AccountDreamboxPage } from '../account-dreambox/account-dreambox.page';
import { AccountInvoicesPage } from '../account-invoices/account-invoices.page';

@Component({
  selector: 'app-account-dashboard-page',
  templateUrl: './account-dashboard.page.html',
  styleUrls: ['./account-dashboard.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AccountDownloadsPage, AccountDreamboxPage, AccountInvoicesPage],
})
export class AccountDashboardPage implements OnInit {
  constructor(private navService: NavService) {}

  ngOnInit(): void {
    this.navService.setNavItems([{ label: 'Account' }]);
  }
}
